import Results from '../components/result/Results';
import './stylePage.css';



function ResultsPage() {
    
        return (
            <>
                <h2 className='title'>Results
                </h2>
                <div className='containerMargin'>
                    <Results />
                </div>
            </>
        );
}

export default ResultsPage;